import { render, staticRenderFns } from "./FadeCarousel.vue?vue&type=template&id=7e8ae4ce&scoped=true"
import script from "./FadeCarousel.vue?vue&type=script&lang=js"
export * from "./FadeCarousel.vue?vue&type=script&lang=js"
import style0 from "./FadeCarousel.vue?vue&type=style&index=0&id=7e8ae4ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8ae4ce",
  null
  
)

export default component.exports